// @flow
import { connect } from 'react-redux';
import { checkAuthState, logout } from 'client/actions';
// eslint-disable-next-line import/extensions
import Main from './Main';

const mapState = (state: ClientStore) => ({
	checklistInfo: state.checklist.item,
	galleryItems: state.galleryItems.items,
	selectedItems: state.selectedItems.items,
	userInfo: state.userInfo,
});
const mapDispatch = {
	checkAuthState,
	logout,
};

export default connect(mapState, mapDispatch)(Main);
